



















































import { mapActions, mapGetters } from 'vuex'
import XForm from '@/components/atoms/Form/XForm.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XPasswordInput from '@/components/atoms/Input/XPasswordInput.vue'
import { ResetPasswordInput } from '@/types/generated/graphql'
import toastMixin from '@/mixin/toastMixin'

type DataType = { input: ResetPasswordInput & { passwordConfirm: string } }

export default toastMixin.extend({
  components: { XForm, XButton, XInput, XPasswordInput },
  data(): DataType {
    return {
      input: {
        token: '',
        email: '',
        password: '',
        passwordConfirm: '',
      },
    }
  },
  created() {
    this.input.email = this.$route.query.email as string
    this.input.token = this.$route.params.token as string
  },
  computed: {
    ...mapGetters('loading', ['isLoading']),
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    async handleSend() {
      const { passwordConfirm, ...rest } = this.input
      await this.resetPassword(rest).then(() => {
        this.showToast(this.$tc('resetpassword.resetSuccess'))
        this.redirect()
      })
    },
    redirect() {
      this.$router.replace(this.$route.params.wantedRoute || { name: 'Login' })
    },
  },
})
